import { createSlice } from '@reduxjs/toolkit';

export default createSlice({
  name: 'misc',
  initialState: {
    isOffline: false,
  },
  reducers: {
    setOffline: (state) => {
      state.isOffline = true;
    },
    setOnline: (state) => {
      state.isOffline = false;
    },
  },
});
